<template>
  <message-dialog
    v-model="dialogOpen"
    title="Beta Feature"
    with-close
    column
  >
    <mira-logo
      type="horizontal"
      width="100px"
      height="26px"
      class="q-mb-md"
    />
    <q-item-label class="text-body1">
      You are currently using the beta feature:<br /><b>{{ featureName }}</b>
    </q-item-label>
    <q-item-label>
      Beta features are still in development, may contain bugs and could change based on feedback.
    </q-item-label>
    <q-item-label class="text-bold">
      If you have any feedback about this feature, don't hesitate to contact our team.
    </q-item-label>

    <template #actions>
      <q-btn
        v-close-popup
        label="Report Problem"
        flat
        no-caps
        align="left"
        class="full-width"
        padding="md md"
        icon="mdi-bug"
        color="blue-8"
        @click="reportIssueLive"
      />
      <q-btn
        v-close-popup
        label="Leave Feedback"
        flat
        no-caps
        align="left"
        class="full-width"
        padding="md md"
        icon="mdi-comment-quote"
        color="blue-8"
        @click="leaveFeedbackLive"
      />
      <q-btn
        v-close-popup
        label="Open Help Center"
        flat
        no-caps
        align="left"
        class="full-width"
        padding="md md"
        icon="mdi-help-circle-outline"
        @click="$bus.emit('help:toggle', true)"
      />
    </template>
  </message-dialog>
</template>

<script>
// Refer to https://quasar.dev/quasar-plugins/dialog#Invoking-custom-component
export default {
  props: {
    featureName: {
      type: String,
      required: true
    }
  },
  emits: [
    // REQUIRED
    'ok', 'hide'
  ],
  data () {
    return {
      supportEnv: process.env.SUPPORT,
      dialogOpen: false
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.dialogOpen = true
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.dialogOpen = false
    },
    reportIssueLive () {
      this.$intercom.showNewMessage('Beta Feature: ' + this.featureName + '\n\nIssue: ')
    },
    leaveFeedbackLive () {
      this.$intercom.showNewMessage('Beta Feature: ' + this.featureName + '\n\nFeedback: ')
    }
  }
}
</script>
